import React from "react";

export default function RecomendacionesDieteticasGenerales() {
  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Recomendaciones dietéticas generales</h4>
      </div>

      {/* Texto + descargable */}
      <div className="flex flex-col gap-4 mt-2">

        {/* Recomendaciones */}
        <div className="bg-[#f4f8fc] p-6 rounded-lg shadow">
          <div className="text-justify space-y-4">
            <p>Ingiera una dieta equilibrada y variada (DIETA MEDITERRÁNEA).</p>

            <hr className="border-gray-300" />

            <p>Adapte la dieta a sus gustos y estado de salud o presencia de otras enfermedades (diabetes, hipertensión arterial…).</p>

            <hr className="border-gray-300" />

            <p>Las raciones deben ser pequeñas pero frecuentes (5-6 veces/día).</p>

            <hr className="border-gray-300" />

            <p>Mantenga una correcta hidratación 2-2,5 litros/día modificando la viscosidad y el volumen según la pauta indicada por el profesional sanitario.</p>
          </div>
        </div>

        {/* Recuerde */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="text-justify font-semibold mb-4">
            RECUERDE:
          </p>

          <ol className="text-justify list-decimal list-inside space-y-2">
            <li>Deberá espesar cualquier tipo de líquido (agua, zumos, leche, infusiones, caldos sin pasta) a la viscosidad y volumen indicados por el profesional sanitario.</li>
            <li>En caso de duda, consulte con su profesional sanitario.</li>
          </ol>
        </div>

        {/* Descargable */}
        <div className="flex items-center">
          <p className="text-justify gap-4 mt-2 mb-4">
            Si desea obtener el descargable, pulse en el siguiente{" "}
            <a
              href="/docs/recomendaciones-dieteticas-generales.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
            enlace
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}